import Rest from '@/services/Rest'

export default class PatientConstraintCodingSchemaService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/patientConstraintCodingSchemas'

}
